export const SET_FILTERS = 'SET_FILTERS'
export const SET_SCROLL_INTO_VIEW = 'SET_SCROLL_INTO_VIEW'
